import { get as getClient, post as postClient } from "../../common/modules/http.client";

export const get = async (url) => {
  if (process.env.NODE_ENV === "development") {
    return getClient(url);
  }
  return await window.AP.request({
    url: url,
    contentType: "application/json",
  });
};

export const post = async (url, data) => {
  if (process.env.NODE_ENV === "development") {
    return postClient(url, data);
  }
  return await window.AP.request({
    url: url,
    type: "POST",
    data: JSON.stringify(data),
    contentType: "application/json",
  });
};
export const isJira = () => {
  if (process.env.NODE_ENV === "development") {
    return true;
  }
  if (window.AP != undefined && window.AP.jira != undefined) {
    return true;
  }
  return false;
};
export const isConfluence = () => {
  if (window.AP != undefined && window.AP.confluence != undefined) {
    return true;
  }
  return false;
};

export const getAppWebLocationInJira = () => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === "development") {
      return resolve(""); // Resolve the promise immediately in development
    }

    if (window.AP != undefined) {
      window.AP.getLocation(function (location) {
        //console.log("location", location);
        resolve(decodeURI(location)); // Resolve the promise with the updated jiraUrl
      });
    } else {
      reject(new Error("AP is not defined")); // Reject the promise if AP is not defined
    }
  });
};

export const enableTheme = () => {
  if (process.env.NODE_ENV === "development") {
    return;
  }
  if (window.AP != undefined) {
    window?.AP?.theming?.initializeTheming();
  }
  return;
};
export const isDarkmode = () => {
  // Ensure the theme is set on page load
  if (!document.documentElement.hasAttribute("data-color-mode")) {
    // Fallback to system preference if no attribute is found
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const defaultMode = prefersDark ? "dark" : "light";
    document.documentElement.setAttribute("data-color-mode", defaultMode);
  }

  // Get the current theme attribute
  const dataTheme = document.documentElement.getAttribute("data-color-mode");

  // Check if the theme is dark
  return dataTheme === "dark";
};
